import { observer } from 'mobx-react';
import { FC, useState } from 'react';

import { ButtonToggle, Flex } from '@servicetitan/anvil2';
import thumbDownAlt from '@servicetitan/anvil2/assets/icons/material/round/thumb_down_alt.svg';
import thumbUpAlt from '@servicetitan/anvil2/assets/icons/material/round/thumb_up_alt.svg';
import { useDependencies } from '@servicetitan/react-ioc';

import { QuestionsStore } from '../../../question-picker/stores/questions.store';
import { MessageType } from '../../models/message-type.model';
import { ChatStore } from '../../stores/chat.store';

export const Feedback: FC = observer(() => {
    const [questionsStore, chatStore] = useDependencies<[QuestionsStore, ChatStore]>(
        QuestionsStore,
        ChatStore
    );
    const [selected, setSelected] = useState<boolean>();

    const handleYes = () => {
        setSelected(true);
        questionsStore.handleFeedbackYes();
    };

    const handleNo = () => {
        setSelected(false);
        chatStore.enqueueMessages([
            {
                showAvatar: true,
                isMine: false,
                type: MessageType.Text,
                text: `I'm sorry I couldn't assist you better. How would you like to proceed?`,
            },
            {
                isMine: false,
                showAvatar: false,
                type: MessageType.FeedbackOptions,
                date: new Date(),
            },
        ]);
        questionsStore.handleFeedbackNo('');
    };

    return (
        <Flex gap="2">
            <ButtonToggle checked={selected} icon={thumbUpAlt} onClick={handleYes} />
            <ButtonToggle checked={selected === false} icon={thumbDownAlt} onClick={handleNo} />
        </Flex>
    );
});
